import { Button, Text } from '@ksyos/design-system';
import React from 'react';
import { formatString } from '@common/utils/formatString';
import { useAbortSignal } from '@frontend/utils/hooks/useAbortSignal';
import { window } from '@frontend/utils/window';
import type { IOrganization } from '../../../interfaces/organization';
import type { EmploymentSwitch } from '../types/employmentSwitch';
import { getSelectedLanguage } from '../../../../translate';
import { Modal } from '../../modals/Modal';
import { changeToEmployment } from '../changeToEmployment';

export type EmploymentSwitchModalProps = {
    currentOrganization: Pick<IOrganization, 'id' | 'name'>;
    employmentSwitch: EmploymentSwitch | null;
    setEmploymentSwitch: React.Dispatch<React.SetStateAction<EmploymentSwitch | null>>;
};

export function EmploymentSwitchModal(props: EmploymentSwitchModalProps) {
    const translate = getSelectedLanguage();
    const abortSignal = useAbortSignal();

    if (!props.employmentSwitch) {
        return null;
    }

    return (
        <Modal
            actionButtons={[
                <Button
                    key="button-no"
                    onClick={() => props.setEmploymentSwitch(null)}
                    variant="outline"
                >
                    {translate.common.no}
                </Button>,
                <Button
                    key="button-yes"
                    onClick={async () => {
                        if (!props.employmentSwitch) {
                            return;
                        }

                        await changeToEmployment(props.employmentSwitch.target.id, abortSignal, () => {
                            window.redirect('/home');
                        });
                    }}
                    variant="solid"
                >
                    {translate.common.yes}
                </Button>,
            ]}
            isOpen={true}
            onClose={() => props.setEmploymentSwitch(null)}
            size="small"
            title={translate.organizationSwitchModal.switchOrganization}
        >
            <Text mb={4}>
                {formatString(translate.organizationSwitchModal.fromTo, [
                    props.currentOrganization.name,
                    props.employmentSwitch.target.organization.name,
                ])}{' '}
                {props.employmentSwitch.reason === 'patientContext' &&
                    translate.organizationSwitchModal.leavingSelectedPatient}
                {props.employmentSwitch.reason === 'noAccess' && translate.organizationSwitchModal.leavingSelectedPage}
            </Text>
            <Text>{translate.organizationSwitchModal.confirmSwitch}</Text>
        </Modal>
    );
}
